import React, { useEffect, useState } from "react";
import Dashboard from "../Dashboard";
import ListSupportTickets from "../../../features/adminDashboard/supportTickets/ListSupportTickets";
import CreateSupportTicket from "../../../features/adminDashboard/supportTickets/CreateSupportTicket";

function SupportTickets() {
  const [activeTab, setActiveTab] = useState("list");
  return (
    <Dashboard>
      <div className="flex space-x-1 bg-gray-100 p-1 rounded-lg mb-6">
        <button
          onClick={() => setActiveTab("list")}
          className={`flex-1 py-2 px-4 rounded-md text-sm font-medium transition-colors ${
            activeTab === "list"
              ? "bg-white text-gray-900 shadow-sm"
              : "text-gray-600 hover:text-gray-900"
          }`}
        >
          List support tickets
        </button>
        <button
          onClick={() => setActiveTab("create")}
          className={`flex-1 py-2 px-4 rounded-md text-sm font-medium transition-colors ${
            activeTab === "create"
              ? "bg-white text-gray-900 shadow-sm"
              : "text-gray-600 hover:text-gray-900"
          }`}
        >
          Create Support Tickets
          {/* {editingProduct ? "Edit Product" : "Create Product"} */}
        </button>
      </div>
      {activeTab === "list" && (
        <ListSupportTickets onSetActiveTab={setActiveTab} />
      )}
      {activeTab === "create" && (
        <CreateSupportTicket onSetActiveTab={setActiveTab} />
      )}
    </Dashboard>
  );
}

export default SupportTickets;
